import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type CustomerPortalLinkResponseType = {
  customer_portal_url: string;
};

export const getCustomerPortalLinkApi = (): Promise<ApiResponseType<CustomerPortalLinkResponseType>> => {
  const uri = '/billing/customer_portal/';

  return authApiService.POST(uri, {});
};
